import { createI18n } from 'vue-i18n';
import { tol } from 'src/boot/tolgee';
import { safeBoot } from 'src/utils/bootSafety';

/**
 * i18n boot file
 *
 * IMPORTANT: All translations are now managed via Tolgee only.
 * The vue-i18n files in src/i18n/ have been removed.
 * Translations are loaded from src/tolgee/i18n/*.json
 *
 * - Use $t() in templates (provided by Tolgee's VueTolgee plugin)
 * - Use t() from useTranslate() in script setup
 * - Use tol.t() for direct access
 */

function browserLocale() {
  const lang = navigator.language;
  if (lang.startsWith('de')) return 'de';
  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('fr')) return 'fr';
  if (lang.startsWith('nl')) return 'nl';
  if (lang.startsWith('it')) return 'it';
  if (lang.startsWith('zh')) return 'zh';
  else return 'en';
}

// Keep minimal vue-i18n for Quasar component compatibility
const instance = createI18n({
  legacy: false,
  locale: browserLocale(),
  globalInjection: true,
  fallbackLocale: 'en',
  messages: {}, // Empty - all translations via Tolgee
});

export default safeBoot('i18n', ({ app }) => {
  app.use(instance);
});

// Primary translation interface is Tolgee
export const i18n = tol;
